module.exports = __webpack_public_path__ + "static/media/IBi-logo.4ad55261.png";